import React, { useMemo, useCallback } from 'react';
import { ToggleButtonGroup, ToggleButton } from '../../../ui-kit';
import { connect } from 'react-redux';
import { updatePoll } from '../../../../state/modules/announcements/operations';

const AnnouncementPollForm = ({ poll, currentUser, updatePoll }) => {
  const handleChange = useCallback(
    answerId => updatePoll(poll.id, answerId, currentUser.id),
    [currentUser, poll, updatePoll]
  );

  const selectedOptionId = useMemo(() => {
    const selectedOption = poll.answers.find(answer => answer.voter_ids.includes(currentUser.id));
    return selectedOption?.id || null;
  }, [currentUser, poll]);

  return (
    <ToggleButtonGroup
      type="radio"
      name={`poll_answers_${poll.id}`}
      value={selectedOptionId}
      className="mb-2"
      onChange={handleChange}
    >
      {poll.answers.map(answer => (
        <ToggleButton
          id={`poll_answer_${answer.id}`}
          size="sm"
          variant={selectedOptionId === answer.id ? 'primary' : 'outline-primary'}
          key={answer.id}
          value={answer.id}
        >
          {answer.answer}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

const mapStateToProps = state => ({
  currentUser: state.currentUser.data
});

const mapDispatchToProps = {
  updatePoll
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementPollForm);
